import React, { useEffect, useState } from 'react';
import PermissionAllowed from '../../../ui-component/permissions/PermissionAllowed';
import CreditNotesStatsComponent from '../../dashboard/Default/components/contact/CreditNotesStatsComponent';
import ProductsStatsComponent from '../../dashboard/Default/components/contact/ProductsStatsComponent';
import InvoiceComparisonWidgetComponent from '../../dashboard/Default/components/InvoiceComparisonWidgetComponent';
import InvoicesStatsComponent from '../../dashboard/Default/components/contact/InvoicesStatsComponent';
import StatsCountComponent from '../../dashboard/Default/components/contact/StatsCountComponent';
import PurchaseOrderStatsComponent from '../../dashboard/Default/components/contact/PurchaseOrderStatsComponent';
import PurchaseOrderPaymentComparisonComponent from '../../dashboard/Default/components/contact/PurchaseOrderPaymentComparisonComponent';
import SupplierPurchaseOrderProductsStatsComponent from '../../dashboard/Default/components/contact/SupplierPurchaseOrderProductsStatsComponent';
import { Skeleton } from '@mui/material';
import CreditNotes from 'assets/images/creditNotes.svg'
import Invoices from 'assets/images/invoices.svg'
import { useDispatch, useSelector } from 'react-redux';
import { HiOutlineDeviceMobile, HiOutlineDocumentReport } from 'react-icons/hi';
import {
	MoneyIcon,
	PurchaseInvoiceIcon,
} from 'ui-component/custom-icons/icons';



// ✅ Clear
const StatsTabComponent = ({ id, contactType }) => {

	const selectedCurrency = useSelector((state) => state.main.selectedCurrency);
	const [products, setProducts] = useState([]);
	const [creditNotesInvoices, setCreditNotesInvoices] = useState([]);
	const [purchaseOrders, setPurchaseOrders] = useState([]);
	const [purchaseOrderProducts, setPurchaseOrderProducts] = useState([]);
	const [invoicesStats, setInvoicesStats] = useState([]);
	const [invoicePaymentSummary, setInvoicePaymentSummary] = useState([]);
	const [purchaseOrderPaymentComparisonStats, setPurchaseOrderPaymentComparisonStats] = useState({});
	const [statsCount, setStatsCount] = useState({});

	
	const [isLoading, setIsLoading] = useState(true);



	const getData = () => {
		setIsLoading(true);
		api.getContactStats(id).then((res) => {
			setIsLoading(false);
			setProducts(res?.data?.products || []);
			setCreditNotesInvoices(res?.data?.credit_notes || []);
			setPurchaseOrders(res?.data?.purchase_orders || []);
			setPurchaseOrderProducts(res?.data?.purchase_order_products || []);
			setInvoicesStats(res?.data?.invoice_stats || []);
			setInvoicePaymentSummary(res?.data?.invoice_payment_summary || []);
			setStatsCount(res?.data?.counts || {});
			setPurchaseOrderPaymentComparisonStats(res?.data?.purchase_order_payment_comparison || {});
			setIsLoading(false);
		});
	}

	useEffect(() => {
		getData()
	}, [])

	return (
		<div className='col-12' style={{ padding: '10px' }}>
			<div className="row">
				<div className="col-12">
					<div className="row">
						{
							isLoading ? (
								<>
									<div className="col-12 col-md-4 flex gap-1" style={{ marginBottom: '20px' }}>
										
										<div className="contacts-count-widget-card">
											<div style={{display: 'flex', alignItems: 'center', gap: '15px'}}>
												<Skeleton variant="circular" width={40} height={40} style={{ borderRadius: '32px' }} />
												<div style={{ flex: 1 }}>
													<Skeleton variant="text" width={'80%'} height={30} style={{ borderRadius: '4px' }} />
													<Skeleton variant="text" width={'50%'} height={20} style={{ borderRadius: '4px' }} />
												</div>
											</div>
										</div>
									</div>
									<div className="col-12 col-md-4" style={{ marginBottom: '20px' }}>
										<div className="contacts-count-widget-card">
											<div style={{display: 'flex', alignItems: 'center', gap: '15px'}}>
												<Skeleton variant="circular" width={40} height={40} style={{ borderRadius: '32px' }} />
												<div style={{ flex: 1 }}>
													<Skeleton variant="text" width={'80%'} height={30} style={{ borderRadius: '4px' }} />
													<Skeleton variant="text" width={'50%'} height={20} style={{ borderRadius: '4px' }} />
												</div>
											</div>
										</div>
									</div>
									<div className="col-12 col-md-4" style={{ marginBottom: '20px' }}>
										<div className="contacts-count-widget-card">
											<div style={{display: 'flex', alignItems: 'center', gap: '15px'}}>
												<Skeleton variant="circular" width={40} height={40} style={{ borderRadius: '32px' }} />
												<div style={{ flex: 1 }}>
													<Skeleton variant="text" width={'80%'} height={30} style={{ borderRadius: '4px' }} />
													<Skeleton variant="text" width={'50%'} height={20} style={{ borderRadius: '4px' }} />
												</div>
											</div>
										</div>
									</div>
								</>
							) : (
								contactType === 'supplier' ? (
									<>
										<div className="col-12 col-md-4" style={{ marginBottom: '20px' }}>
											<StatsCountComponent
												name="Total Purchase Orders"
												count={statsCount?.['total_purchase_orders']}
												isLoading={isLoading}
												icon={<PurchaseInvoiceIcon width={'29px'} height={'29px'} />}
												type={'integer'}
											/>
										</div>
										<div className="col-12 col-md-4" style={{ marginBottom: '20px' }}>
											<StatsCountComponent
												name="Purchased Products"
												count={statsCount?.['total_purchase_order_products']}
												isLoading={isLoading}
												icon={<HiOutlineDeviceMobile style={{ fontSize: '2.4em', color: '#0068fa' }} />}
												type={'integer'}
											/>
										</div>
										<div className="col-12 col-md-4" style={{ marginBottom: '20px' }}>
											
											<StatsCountComponent
												name="Total Amount"
												// count={statsCount?.['total_products']}
												count={statsCount?.total_convereted_purchase_order_amount ? statsCount?.total_convereted_purchase_order_amount[selectedCurrency] : '0'}
												isLoading={isLoading}
												icon={<MoneyIcon width={'30px'} height={'30px'} />}
												type={'float'}
											/>
										</div>
									</>
								) : (
									<>
										<div className="col-12 col-md-4" style={{ marginBottom: '20px' }}>
											<StatsCountComponent
												name="Total Invoices"
												count={statsCount?.['total_invoices']}
												isLoading={isLoading}
												icon={<img src={Invoices} alt="Invoices Icon" width="30" height="30" />}
												type={'integer'}
											/>
										</div>
										<div className="col-12 col-md-4" style={{ marginBottom: '20px' }}>
											<StatsCountComponent
												name="Total Credit Notes"
												count={statsCount?.['total_credit_notes']}
												isLoading={isLoading}
												icon={<img src={CreditNotes} alt="Credit Notes Icon" width="30" height="30" />}
												type={'integer'}
											/>
										</div>
										<div className="col-12 col-md-4" style={{ marginBottom: '20px' }}>
											<StatsCountComponent
												name="Total Products"
												count={statsCount?.['total_products']}
												isLoading={isLoading}
												icon={<HiOutlineDeviceMobile style={{ fontSize: '2.5em', color: '#0068fa' }} />}
												type={'integer'}
											/>
										</div>
									</>
								)
							)
						}
					</div>
				</div>

				{
					isLoading ? (
						[...Array(4)].map((e, i) => (
							<div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xxl-6" style={{ marginBottom: '20px' }}>
								<div className="card" style={{ height: '250px' }}>
									<div className="card-body" style={{ padding: '15px', zIndex: '1' }}>
										<div className="flex justify-content-between">
											<div className="text-lg fw-500" style={{ width: '100px' }}>
												<Skeleton variant="rounded" width={'100%'} height={20} style={{ borderRadius: '32px' }} />
											</div>
											<div className="flex gap-1 absolute" style={{ right: '20px', top: '6px' }}>
												
												<div style={{ width: '100px', marginTop: '8px' }}>
													<Skeleton variant="rounded" width={'100%'} height={20} style={{ borderRadius: '32px' }} />
												</div>
											</div>
										</div>
										<div className="overflow-y-auto custom-scrollbar " style={{ maxHeight: '185px', margin: '10px 0' }}>
											{
												[...Array(15)].map((e, i) => (
													<div key={i} className="row" style={{ padding: '5px 0' }}>
														<div className="col-12">
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
														</div>
													</div>
												))
											}
										</div>
									</div>
								</div>
							</div>
						))
					) : (
						contactType === 'supplier' ? (
							<>
								<div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xxl-6">
									<div className="row">
										<div className="col-12" style={{ marginBottom: '20px' }}>

											<PurchaseOrderPaymentComparisonComponent
												details={purchaseOrderPaymentComparisonStats}
												isLoading={isLoading}
											/>
										</div>
										<div className="col-12" style={{ marginBottom: '20px' }}>

											<PurchaseOrderStatsComponent
												details={purchaseOrders}
												isLoading={isLoading}
											/>
										</div>
									</div>
								</div>
								<div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xxl-6" style={{ marginBottom: '20px' }}>
									<SupplierPurchaseOrderProductsStatsComponent
										details={purchaseOrderProducts}
										isLoading={isLoading}
									/>
								</div>
							</>
						) : (
							<>
								<PermissionAllowed permissions={['List Contact (Page)']}>
									<div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xxl-6" style={{ marginBottom: '20px' }}>
										<CreditNotesStatsComponent
											details={creditNotesInvoices}
											isLoading={isLoading}
										/>
									</div>
								</PermissionAllowed>
								<PermissionAllowed permissions={['List Contact (Page)']}>
									<div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xxl-6" style={{ marginBottom: '20px' }}>
										<InvoicesStatsComponent
											details={invoicesStats}
											isLoading={isLoading}
										/>
									</div>
								</PermissionAllowed>
								<PermissionAllowed permissions={['List Contact (Page)']}>
									<div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xxl-6" style={{ marginBottom: '20px' }}>
										<InvoiceComparisonWidgetComponent
											details={invoicePaymentSummary}
											isLoading={isLoading}
										/>
									</div>
								</PermissionAllowed>
								<PermissionAllowed permissions={['List Contact (Page)']}>
									<div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xxl-6" style={{ marginBottom: '20px' }}>
										<ProductsStatsComponent
											details={products}
											isLoading={isLoading}
										/>
									</div>
								</PermissionAllowed>
							</>
						)
					)
				}
			</div>
		</div>
	);
};

export default StatsTabComponent;